module.exports = __webpack_public_path__ + "img/claims-image-3.b4b5ab5f.png";